import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CarouselType, CarouselViewModel } from '../../../public-api';
import { CarouselItemImpressionEventInfo, CarouselItemSelectEventInfo } from '../../interfaces/carousel-item-select-gtm.interface';
import { Screen, ScreenService } from '../../services';
import { recommendationCarouselPlaceholderVariable } from './recommendation-carousel-placeholder-variable';
import { RecommendationCarouselViewModel } from './recommendation-carousel.view-model';

@Component({
  selector: 'osn-shared-recommendation-carousel',
  templateUrl: './recommendation-carousel.component.html',
  styleUrls: ['./recommendation-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationCarouselComponent {
  @Output() public carouselItemSelect: EventEmitter<CarouselItemSelectEventInfo> = new EventEmitter();
  @Output() public carouselItemImpression = new EventEmitter<CarouselItemImpressionEventInfo>();
  private readonly basedOnTitlePlaceholder = recommendationCarouselPlaceholderVariable;

  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  private _vm: RecommendationCarouselViewModel;
  public carouselViewModel: CarouselViewModel;
  public canNavigateOnTitleClick = true;

  constructor(private readonly screenService: ScreenService) {}

  @Input() public set vm(vm: RecommendationCarouselViewModel) {
    this._vm = vm;
    this.carouselViewModel = {
      items: vm.items,
      layout: vm.layout,
      type: CarouselType.RecommendationCarousel,
      resolved: vm.resolved,
      isTop10: vm.isTop10,
    };
  }

  public get vm() {
    return this._vm;
  }

  public get routerLink(): string {
    return this.vm.routerLink;
  }

  public get visible(): boolean {
    return !!this.vm && (!this.vm.resolved || (this.vm.resolved && this.vm.items && this.vm.items.length > 0));
  }

  public get showCarouselTitle(): boolean {
    return !this.vm.titleToDisplay.includes(this.basedOnTitlePlaceholder);
  }

  public get titlePlaceholderHeight$(): Observable<number> {
    // TODO - should fix shimmer-loading-component to accept proper values.

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return this.screenService.changed$.pipe(map((screen) => (screen === Screen.XS ? 15 : 5)));
  }

  @HostBinding('class.carousel-container')
  public get carouselContainerClass() {
    return this.visible;
  }

  public onCarouselItemImpression(contentInfo: { guid: string; index: number; carouselItemType: string }): void {
    this.carouselItemImpression.emit({
      guid: contentInfo.guid,
      index: contentInfo.index,
      carouselTitle: this._vm.titleLocalized.en,
      carouselItemType: contentInfo.carouselItemType,
    });
  }

  public onCarouselItemSelect({ carouselItemDetails, carouselTitle }): void {
    this.carouselItemSelect.emit({ guid: carouselItemDetails.id, carouselTitle, carouselItemType: carouselItemDetails.category });
  }
}
